//export const SERVER_API_URL = 'http://localhost:8081/api';
export const SERVER_API_URL = 'https://etudiant-pgi.esp.sn:8080/api';
//export const SERVER_API_URL_CONSULTATION = 'https://comptamat.esp.sn:120';
export const SERVER_API_URL_CONSULTATION = 'https://etudiant-pgi.esp.sn:8080';

export const DATE_FORMAT = 'YYYY-MM-DD';
export const DATE_TIME_FORMAT = 'YYYY-MM-DDTHH:mm';

export const DATE_TIME_FORMAT2 = 'YYYY-MM-DDTHH:mm:ssZ';
export const TIME_FORMAT = 'HH:mm';
